export default "__VITE_ASSET__DIKZjWjA__"